export const MINIMUM_PHONE_LENGTH = 4;

export const INVALID_PHONE_NUMBER = 'Invalid number';
export const INVALID_PHONE_NDC_NOT_FOUND = 'NDC Not Found';
